import React, { FC, useState } from 'react';
import { Asset, Button, CalendarMinimalIcon, Modal } from '@clearcover/atlas';
import { PaymentPlanType } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import styles from './styles.module.css';
import { PaymentScheduleModalContent } from './PaymentScheduleModalContent';

export const PaymentScheduleModal: FC<{ currentPlan: PaymentPlanType }> = ({
  currentPlan,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        className={styles.paymentScheduleButton}
        block
        link
        onClick={() => setOpen(true)}
      >
        <Asset
          icon={CalendarMinimalIcon}
          description="view-payment-schedule-calendar-icon"
          height={20}
          width={20}
        />
        View Payment Schedule
      </Button>
      <Modal
        controlled={true}
        open={open}
        variant="normal"
        handleClose={() => setOpen(false)}
      >
        {closeModal => (
          <PaymentScheduleModalContent
            paymentPlan={currentPlan}
            closeModal={closeModal}
          />
        )}
      </Modal>
    </>
  );
};
